import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpModelFilterableBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filterable-base-component';
import { WizardHpModelFilterBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filter-base-component';
import { SelecteurPorteComponent } from 'projects/hp-api/src/lib/selecteur-porte/selecteur-porte.component';
import { WizardElementsFilterMenuComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-elements-filter-menu.component';



@Component({
  selector: 'app-wizard-selecteur-porte-filter-menu',
  templateUrl: '../base/wizard/wizard-elements-filter-menu.component.html',
  styleUrls: ['../base/wizard/wizard-hp-base-component.scss', '../base/wizard/wizard-elements-filter-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardHpModelFilterSelecteurPorteComponent extends WizardElementsFilterMenuComponent implements OnInit {
  @Input() selecteurPorteComponent: SelecteurPorteComponent;

  constructor(chgDetectorRef: ChangeDetectorRef, 
     hpService: HpService, router: Router) {
      super(chgDetectorRef, hpService, router);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setLinkedFilterable(this.selecteurPorteComponent);
  }

}
